import {
  IEventBuilder, IEventSender, ObjectMap,
} from './interfaces'
import {
  logger, getApiUrlFromConfig
} from '../utils'
import { sendToEndpoint } from '../utils/sendToEndpoint'
import PsmResponseProcessor from './psm-response-processor'
import PsmBridge from './psm-bridge'
import { CCPA_LOCATIONS } from '../../../psm-core/src/utils/constants'

class PsmEventSender implements IEventSender {
  dispatchQueue: ObjectMap[]
  eventBuilder: IEventBuilder
  locationAccepted: boolean

  constructor(eventBuilder: IEventBuilder) {
    this.eventBuilder = eventBuilder
    this.dispatchQueue = []
    this.locationAccepted = CCPA_LOCATIONS.indexOf(PsmBridge.psm.getLocationProperties().country) > 0
  }

  async sendEvents() {
    logger('event sender triggered')
    this.dispatchQueue = this.getDispatchQueue()

    if (this.dispatchQueue.length > 0 && !PsmBridge.isThrottlingRequested && this.locationAccepted) {
      logger('sending dispatch queue')
      const apiUrl = getApiUrlFromConfig()
      const response = await sendToEndpoint(apiUrl, this.dispatchQueue)
      const responseProcessor = new PsmResponseProcessor()
      responseProcessor.handleResponse(response, this)
    } else if ((this.dispatchQueue.length > 0 && PsmBridge.isThrottlingRequested) || !this.locationAccepted) {
      logger('clearing dispatch queue')
      this.clearDispatchQueue()
    }
    else {
      logger('dispatch queue is empty')
    }
  }

  getDispatchQueue(): ObjectMap[] {
    const sentAtTimestamp = new Date().toISOString()
    const queuedEvents = this.eventBuilder.getEventQueue()

    const finalEvent = queuedEvents.map((event: any) => {
      const eventWithSentAtTimestamp = Object.assign({}, event, {
        sentAtTimestamp,
      })
      return eventWithSentAtTimestamp
    })

    return finalEvent
  }

  clearDispatchQueue(): void {
    this.dispatchQueue = []
  }
}

export default PsmEventSender
